import classNames from "classnames";
import styles from "./style.module.scss";
import CustomModal from "shared/components/common/customModal";
import { Icons, Images } from "assets";
import CustomButton from "shared/components/common/customButton";
import { Link } from "react-router-dom";
import moment from "moment";

interface ListingDetails {
  name: string;
  bio?: string;
  phone: string;
  address: string;
  city: string;
  postal_code?: string;
  website_url?: string;
  email_notifications?: string;
  profileImage?: string | any;
  services?: { name: string }[];
  certificates?: [];
  customerType?: number;
  email?: string;
  service_areas?: string[];
  avatar?: string;
}

interface Props extends ModalProps {
  listingDetails: ListingDetails;
  handleSubmit?: () => void;
  actionButtonText?: string;
  loading?: boolean;
  isHaveServices?: boolean;
  isMessagesModal?: boolean;
  isHaveCustomerType?: boolean;
  isShowAvatar?: boolean;
  title?: string;
}

const ViewCustomerModal = ({
  title,
  listingDetails,
  actionButtonText,
  loading,
  isHaveServices = false,
  isMessagesModal = false,
  isHaveCustomerType = false,
  isShowAvatar = false,
  show,
  handleClose,
  handleSubmit,
}: Props) => {
  const contentDetails = [
    { label: "Name", value: listingDetails.name },
    listingDetails.email
      ? {
          label: "Email",
          value: listingDetails.email,
        }
      : null,

    isHaveCustomerType
      ? {
          label: "Customer Type",
          value:
            listingDetails.customerType === 0 ? "Home Owner" : "Organization",
        }
      : null,
    { label: isMessagesModal ? "Email" : "Phone", value: listingDetails.phone },
    {
      label: isMessagesModal ? "Message" : "Address",
      value: listingDetails.address,
    },
    {
      label: isMessagesModal ? "Date & Time" : "City",
      value: isMessagesModal
        ? moment(listingDetails.city).format("MMM DD, YYYY")
        : listingDetails.city,
    },
    listingDetails?.bio
      ? {
          label: "Bio",
          value: listingDetails?.bio,
        }
      : null,
    ...(isHaveServices
      ? [{ label: "Website", value: listingDetails.website_url }]
      : []),
  ];

  return show ? (
    <CustomModal onClose={handleClose}>
      <div className={classNames(styles.contentContainer)}>
        <div
          className={classNames(
            "flex items-center justify-between px-4 mt-4 mb-3"
          )}
        >
          <h3 className={styles.modalTitle}>
            {title ? title : "Customer Details"}
          </h3>
          <div
            className={classNames(styles.crossContainer)}
            onClick={() => {
              if (!loading) {
                handleClose();
              }
            }}
          >
            <Icons.Cross />
          </div>
        </div>

        <div
          className={classNames(styles.modalBody, "w-full flex flex-col gap-6")}
        >
          {isShowAvatar ? (
            <div className="flex items-center justify-center">
              <img
                src={
                  listingDetails?.avatar
                    ? listingDetails?.avatar
                    : Images.DefaultAvatar
                }
                height={"90px"}
                width={"90px"}
                alt="Profile avatar"
              />
            </div>
          ) : null}
          <div
            className={classNames(
              styles.customerDetails,
              "grid grid-cols-12 gap-1"
            )}
          >
            {contentDetails?.map((data) =>
              data?.label ? (
                <>
                  <p className={classNames(styles.contentItem, "col-span-2")}>
                    <strong>{data?.label} :</strong>
                  </p>
                  <h6 className="col-span-10">{data?.value}</h6>
                </>
              ) : null
            )}
          </div>

          {isHaveServices && (
            <div>
              {/* Services Section */}
              <p className={styles.contentItem}>
                <strong>Services:</strong>
              </p>
              <div
                className={classNames(
                  styles.servicesContainer,
                  "flex items-start gap-1 flex-wrap mt-3"
                )}
              >
                {listingDetails.services?.length ? (
                  listingDetails.services.map((service, index) => (
                    <h6 key={index} className={classNames()}>
                      {service.name}
                      {listingDetails?.services &&
                        index < listingDetails?.services?.length - 1 &&
                        ","}
                    </h6>
                  ))
                ) : (
                  <p className={classNames(styles.contentItem)}>
                    No services available
                  </p>
                )}
              </div>
            </div>
          )}

          {isHaveServices && (
            <div>
              {/* Services Section */}
              <p className={styles.contentItem}>
                {" "}
                <strong>Certifications:</strong>
              </p>
              <div
                className={classNames(
                  styles.servicesContainer,
                  "flex items-start gap-1 flex-wrap mt-3"
                )}
              >
                {listingDetails.certificates?.length ? (
                  listingDetails.certificates.map((item, index) => (
                    <Link className="underline" to={item} key={index}>
                      <img src={item} height={300} width={200} alt={`Certificate ${index + 1}`} />
                    </Link>
                  ))
                ) : (
                  <p className={classNames(styles.contentItem)}>
                    No Certificates available
                  </p>
                )}
              </div>
            </div>
          )}

          <div
            className={classNames(
              "flex items-center w-full justify-center gap-4"
            )}
          >
            {handleSubmit && (
              <CustomButton
                title={actionButtonText ? actionButtonText : "Proceed"}
                containerStyle={classNames(styles.actionButton, "px-12")}
                onClick={handleSubmit}
                loading={loading}
                disabled={loading}
              />
            )}
          </div>
        </div>
      </div>
    </CustomModal>
  ) : null;
};

export default ViewCustomerModal;
